(() => {
  if (window.__rdBowlFixApplied) return;
  window.__rdBowlFixApplied = true;

  const FLASH_MS = 1600;
  const ADDED_BG = '#3f6b4a';
  const ADDED_BORDER = '#3f6b4a';

  const flashButton = (button) => {
    if (!(button instanceof HTMLElement)) return;

    const label = button.querySelector('[data-rd-bf-button-label]');
    const originalLabel = label ? label.textContent : null;
    const prevBg = button.style.backgroundColor;
    const prevBorder = button.style.borderColor;

    button.style.backgroundColor = ADDED_BG;
    button.style.borderColor = ADDED_BORDER;
    if (label) label.textContent = 'Added \u2713';

    window.setTimeout(() => {
      button.style.backgroundColor = prevBg;
      button.style.borderColor = prevBorder;
      if (label && originalLabel !== null) label.textContent = originalLabel;
    }, FLASH_MS);
  };

  // The Bowl Favourites section calls window.RawDelightsCartFlight.animate(...) on every
  // add-to-bowl click, but nothing previously defined this global, so every click silently
  // did nothing visually. This provides that hook with a real (simple) visual response.
  window.RawDelightsCartFlight = window.RawDelightsCartFlight || {
    animate(detail) {
      const source = detail && detail.source;
      flashButton(source);
    },
  };

  // Fallback path, in case animate() above isn't reached for some reason.
  document.addEventListener('raw-delights:cart-flight', (event) => {
    const source = event.detail && event.detail.source;
    flashButton(source);
  });
})();
